import React from "react";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import { Typography } from "@mui/material";
import I18N from "oc-modules/oc-I18N";
import TableContainer from "@mui/material/TableContainer";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { TableCell } from "@material-ui/core";
import TableBody from "@mui/material/TableBody";
import Button from "@mui/material/Button";
import { styled } from "@mui/system";
import Grid from "@material-ui/core/Grid";
import { useTheme } from "@mui/material/styles";
import AutorenewIcon from "@mui/icons-material/Autorenew";

const StyledTableCell = styled(TableCell)`
  &:last-of-type {
    border-radius: 0;
  }
`;

export default function Partslist() {
  const theme = useTheme();
  const { selectedComb } = APP.arrangement ? APP.arrangement?.state : {};
  const parts = APP.arrangement.partslist.parts;
  const booth = APP.arrangement.partslist.booth;
  const total = APP.arrangement.partslist.total;
  const vat = APP.arrangement.partslist.vatTotal;
  const subTotal = APP.arrangement.partslist.subtotal;
  const basicEquipment = parts.filter((part) => part.type === "BasicEquipment");
  const basicEquiptmentSum = APP.arrangement.partslist.basicTotal;
  const additionalEquipment = parts.filter((part) => part.type === "AdditionalEquipment");
  const additionalEquipmentSum = APP.arrangement.partslist.additionalTotal;

  return (
    <Box>
      <Box
        component={Grid}
        container
        style={{
          marginTop: "30px",
          marginBottom: "30px",
          [theme.breakpoints.up("lg")]: {
            marginTop: "0",
          },
        }}
      >
        <Box
          component={Grid}
          item
          xs={12}
          lg={3}
          style={{
            marginBottom: "8px",
            fontSize: "1.2rem",
            [theme.breakpoints.up("lg")]: {
              marginBottom: "0",
              fontSize: "inherit",
            },
          }}
        >
          {I18N("Booth Selection")}
        </Box>
        <Grid item xs={4} lg={2}>
          <Box sx={{fontWeight: 700}}>{APP.arrangement?.state?.booth?.Displayed_Name}</Box>
        </Grid>
        <Grid item xs={4} lg={2}>
          <Box sx={{fontWeight: 700}}>{APP.arrangement?.state?.selectedComb?.Size?.Label}</Box>
        </Grid>
        <Grid item xs={4} lg={2}>
          <Box sx={{fontWeight: 700}}>{APP.arrangement?.state?.selectedComb?.Booth.Type?.Label}</Box>
        </Grid>
      </Box>

      <Box sx={{ display: "flex" }}>
        <Box
          sx={{
            width: "50%",
            backgroundColor: "#C91113",
            color: "#fff",
            display: "flex",
            alignItems: "center",
            padding: "10px 16px",
          }}
        >
          {I18N("Basic Equipment")}
        </Box>
        <Box
          sx={{
            width: "50%",
            backgroundColor: "#C91113",
            color: "#fff",
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            padding: "10px 16px",
            textAlign: "right",
          }}
        >
          {APP.formatter.format(basicEquiptmentSum)}
        </Box>
      </Box>
      <TableContainer component={Box} sx={{ marginBottom: "0" }}>
        <Table sx={{ tableLayout: "fixed" }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell style={{ width: "10%", color: "#939599" }}>#</TableCell>
              <TableCell style={{ width: "30%", color: "#939599" }}>
                {I18N("Particulars (include Spec.)")}
              </TableCell>
              <TableCell style={{ width: "15%", color: "#939599" }}>{I18N("No")}</TableCell>
              <TableCell style={{ width: "10%", color: "#939599" }}>{I18N("QTY")}</TableCell>
              <TableCell style={{ width: "15%", color: "#939599" }}>{I18N("Unit Price")}</TableCell>
              <TableCell style={{ width: "20%", color: "#939599" }}>
                {I18N("Amount(TWD)")}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {basicEquipment?.map((part, index) => (
              <TableRow
                key={`part${index}`}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <StyledTableCell>{index + 1}</StyledTableCell>
                <StyledTableCell>{part.title}</StyledTableCell>
                <StyledTableCell>{part.ean ? part.ean : "-"}</StyledTableCell>
                <StyledTableCell>{part.amount}</StyledTableCell>
                <StyledTableCell>0</StyledTableCell>
                <StyledTableCell>{I18N("Included")}</StyledTableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Divider sx={{ marginBottom: "30px" }} />
      {/* Todo no AdditionalEquipment and parts array contains basic equipment */}
      <Box sx={{ display: "flex" }}>
        <Box
          sx={{
            width: "50%",
            backgroundColor: "#C91113",
            color: "#fff",
            display: "flex",
            alignItems: "center",
            padding: "10px 16px",
          }}
        >
          {I18N("Additional Equipment")}
        </Box>
        <Box
          sx={{
            width: "50%",
            backgroundColor: "#C91113",
            color: "#fff",
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            padding: "10px 16px",
            textAlign: "right",
          }}
        >
          {APP.formatter.format(additionalEquipmentSum)}
        </Box>
      </Box>
      <TableContainer component={Box} sx={{ marginBottom: "0" }}>
        <Table sx={{ tableLayout: "fixed" }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell style={{ width: "10%", color: "#939599" }}>#</TableCell>
              <TableCell style={{ width: "30%", color: "#939599" }}>
                {I18N("Particulars (include Spec.)")}
              </TableCell>
              <TableCell style={{ width: "15%", color: "#939599" }}>{I18N("No")}</TableCell>
              <TableCell style={{ width: "10%", color: "#939599" }}>{I18N("QTY")}</TableCell>
              <TableCell style={{ width: "15%", color: "#939599" }}>{I18N("Unit Price")}</TableCell>
              <TableCell style={{ width: "20%", color: "#939599" }}>
                {I18N("Amount(TWD)")}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {additionalEquipment?.map((part, index) => (
              <TableRow
                key={`part${index}`}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <StyledTableCell>{index + 1}</StyledTableCell>
                <StyledTableCell>{part.title}</StyledTableCell>
                <StyledTableCell>-</StyledTableCell>
                <StyledTableCell>{part.amount}</StyledTableCell>
                <StyledTableCell>{part.basePrice}</StyledTableCell>
                <StyledTableCell>{part.amount * part.basePrice}</StyledTableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Divider sx={{ marginBottom: "30px" }} />

      <Box sx={{ display: "flex", flexDirection: "column", marginBottom: "60px" }}>
        <Box sx={{ marginBottom: "20px" }}>
          <Typography
            variant={"h6"}
            style={{ color: "#C91113", fontWeight: "700", textTransform: "uppercase" }}
          >
            {I18N("PartslistTotalPrice")}
          </Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "20px",
          }}
        >
          <Box sx={{ fontWeight: "700" }}>{I18N("Subtotal")}</Box>
          <Box sx={{ fontWeight: "900" }}>{APP.formatter.format(subTotal)}</Box>
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "20px",
          }}
        >
          <Box sx={{ fontWeight: "700" }}>
            {I18N("VAT")} ({APP.arrangement.partslist.vat}%)
          </Box>
          <Box>{APP.formatter.format(vat)}</Box>
        </Box>
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <Box sx={{ fontWeight: "700" }}>{I18N("Grand Total")}</Box>
          <Box sx={{ fontWeight: "900" }}>{APP.formatter.format(total)}</Box>
        </Box>
      </Box>
    </Box>
  );
}
